import React, {useState} from "react";
import {Link, useHistory} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Breadcrumb from 'layouts/main/Breadcrumb';
import UIInput from 'components/input/input';
import Button from 'components/buttons/';
import useToggleState from 'components/hooks/useToggleState';
import ModalPopup from 'components/modal/';
import UIDatePicker from "components/datepicker";
import codeDataStore from "../../../../common/codedata/store/CodeDataStore";
import UISelect from "../../../../components/selectbox/UISelect";
import CommonUtil from "../../../../utils/CommonUtil";
import UIUtils from "../../../../utils/UIUtils";
import StringUtil from "../../../../utils/StringUtil";
import UITextArea from "../../../../components/atoms/textarea/UITextArea";
import {Tooltip} from "react-tooltip";
import UI from "../../../../components/UI";
import TbComFile from "domain/main/com/file/TbComFile";
import userStore from "../../../../common/user/store/UserStore";

function ContentsContainer() {
	const serverUrl = 'http://dev.fund.win-win.or.kr/';

	const [modal2007IsOpen, setModal2007IsOpen] = useState(false);
	const [modal2008IsOpen, setModal2008IsOpen] = useState(false);
	const [bizCd,setBizCd] = useState('');
	const [selectBiz,setSelectBiz] = useState({}); //선택한 출연사업
	const [bizNm,setBizNm] = useState(''); //사업명
	const [totalRowCnt,setTotalRowCnt] = useState(0);
	const [showRowCnt,setShowRowCnt] = useState(20); //기본 row count
	const [memo, setMemo] = useState('');

	const modaladm2007 = useToggleState({});
	const modaladm2007_1 = useToggleState({});

	//밑에 담당자 정보
	const [corpNm,setCorpNm] = useState(''); //과제명
	const [bizNo,setBizNo] = useState(''); //사업자번호
	const [corpRegNo,setCorpRegNo] = useState(''); //사업자번호
	const [personNm,setPersonNm] = useState(''); //이름
	const [posiNm,setPosiNm] = useState(''); //직급
	const [deptNm,setDeptNm] = useState(''); //부서명
	const [emailAdres,setEmailAdres] = useState(''); //이메일
	const [ofcTelNo,setOfcTelNo] = useState(''); //전화번호

	const [selectReaminDonAmt,setSelectReaminDonAmt] = useState(0); //선택한 사업 잔액
	const [donAmt,setDonAmt] = useState(0); //출연금액
	const [isChk,setIsChk] = useState(false);
	const [DonReqDate,setDonReqDate] = useState(new Date());
	const [exclReqDate,setExclReqDate] = useState(new Date());
	const [amtList, setAmtList] = React.useState<any[]>([{ EXCL_DON_AMT : 0, BIZ_CD : '', num : 0 , checked : false}]);
	const [nextNum,setNextNum] = useState(1); //amtList 고유 key
	const [type,setType] = useState('M');
	const [isAllChk,setIsAllChk] = useState(false);
	const [totalAmt, setTotalAmt] = useState(0);
	const [isConfirm, setIsConfirm] = useState(false);
	const [elecApprYn, setElecApprYn] = useState('N');
	const [bizList,setBizList] = useState<any>([]);
	const [personId, setPersonId] = useState('');
	const [REC,setREC] = useState<any>([]);

	/** 검색조건 */
	const [startDate,setStartDate] = useState(new Date(new Date().getFullYear()+'-01-01'));
	const [endDate,setEndDate] = useState(new Date(new Date().getFullYear()+'-12-31'));
	const [donNo2008,setDonNo2008] = useState('');
	const [bizCd2008,setBizCd2008] = useState('');

	//파일정보 선언
	const [reqFileNm, setReqFileNm] = useState('');

	const [corpLogoFileValue] = useState(new TbComFile());
	const [bizLicFileValue] = useState(new TbComFile());
	const [fileValue] = useState(new TbComFile());

	const [uploadComp, setUploadComp] = useState(false);
	const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);
	const [fileInfoListPop, setFileInfoListPop] = React.useState<any[]>([]);

	//파일업로드
	const [uploadId, setUploadId] = React.useState("");

	//파일업로드
    const onCreationComplete = function (uploadID: string) {
        setUploadId(uploadID);
    }

	//파일업로드 완료
	const onUploadComplete = () => {
        const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId);
        const arrayNew = dataArray.newFile;
        const arrayDel = dataArray.deleteFile;
	    console.log("arrayNew " ,JSON.stringify(arrayNew));

		let fileInfos : {
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_GB:string;
		}[] = [];

		let fileInfo : {
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_GB:string;
		};

		//파일등록 정보
		arrayNew?.map((item, index) => {
			if(item.status =="complete"){
				fileInfo = {
					ORGINL_FILE_NM:item.originalName,
					STRE_FILE_NM:item.uploadName,
					FILE_SIZE:item.size,
					STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
					FILE_EXTSN:item.extension,
					FILE_GB:""
				}

				fileInfos.push(fileInfo);
			}

			console.log("fileInfos : "+JSON.stringify(fileInfos));
		})

		setFileInfoList(fileInfos);
		setUploadComp(true);
    }

	async function onFileUpload()  {
		if(uploadId){
			await window["RAONKUPLOAD"].Transfer(uploadId);
		}
	}


	/**
   * 출연신청서
   */
	const reqModal = () => {
		UIUtils.openFileUploadPopup({
			title: "전용신청공문",
			buttonTitle: "등록",
			attrs: {
				MaxTotalFileCount: "1",
				ExtensionAllowOrLimit: "1",
			},
			valueChanged: async data => {
				console.log("fileId uploadId : "+ uploadId);
				// @ts-ignore
				if(data != undefined && data.tbComFileMapngDetailList.length != 0){
					const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId);
					const arrayNew = dataArray.newFile;
					const arrayDel = dataArray.deleteFile;
					console.log("arrayNew", JSON.stringify(arrayNew));

					let fileInfos : {
						ORGINL_FILE_NM:string | undefined;
						STRE_FILE_NM:string | undefined;
						FILE_SIZE:number | undefined;
						STRE_PATH:string | undefined;
						FILE_EXTSN:string | undefined;
						FILE_GB:string | undefined;
					}[] = [];

					let fileInfo : {
						ORGINL_FILE_NM:string | undefined;
						STRE_FILE_NM:string | undefined;
						FILE_SIZE:number | undefined;
						STRE_PATH:string | undefined;
						FILE_EXTSN:string | undefined;
						FILE_GB:string | undefined;
					};



					// @ts-ignore
					let item = data.tbComFileMapngDetailList[0];

					// @ts-ignore
					let orginlFileNm = item.orginlFileNm;
					// @ts-ignore
					let streFileNm = item.streFileNm;
					// @ts-ignore
					let fileSize = item.fileSize;
					// @ts-ignore
					let strePath = item.strePath;
					// @ts-ignore
					let fileExtsn = item.fileExtsn;

					//파일등록 정보
					fileInfo = {
						ORGINL_FILE_NM:orginlFileNm,
						STRE_FILE_NM:streFileNm,
						FILE_SIZE:fileSize,
						STRE_PATH: strePath,
						FILE_EXTSN:fileExtsn,
						FILE_GB:'REQ'
					}

					// @ts-ignore
					setReqFileNm(orginlFileNm)

					fileInfos.push(fileInfo);
					setFileInfoListPop(fileInfos);
				}

			}
		})
	}


		async function initCall(){

		let param = {};

		const response:any = await CommonUtil.execute({
			url:'TbComPersonEntityMapper_select_bizno',
			data: param
		})

		const result = response;
		console.log(result)
		if(result.REC.length != 0){
			setREC(result.REC);
			const personId = userStore.userModel?.getPersonId();
			console.log("personId : " + personId)
			let info = result.REC.filter(a => a.PERSON_ID == personId)[0]
			if(info.length == 0){
				info = result.REC[0];
			}

			setPersonId(info.PERSON_ID);
			setCorpNm(info.CORP_NM);
			setBizNo(info.BIZ_NO);
			setCorpRegNo(info.CORP_REG_NO);
			setPersonNm(info.PERSON_NM);
			setPosiNm(info.POSI_NM);
			setDeptNm(info.DEPT_NM);
			setEmailAdres(info.EMAIL_ADRES);
			setOfcTelNo(info.OFC_TEL_NO);
		}

		

		// @ts-ignore
		if(typeof result == 'undefined'){
			alert('data is not loaded!!!')
			return;
		}
	};

	const history = useHistory();

	const handleSelect = (e) => {
		let engReg = /[^a-zA-Z]/g;
		let numReg = /[^0-9]/g;
		let name = e.target.name;

		let type = name.replace('select', '').replace(engReg, '').toLowerCase();
		let index = name.replace(numReg, '');

		if(bizCd == e.target.value){
			UIUtils.alert('출연사업과 동일한 사업은 선택할수없습니다.').then();
			return
		}

		changeVal(e.target.value, type, index);
	};

	function changeVal(val, type, index){
		let newList = [...amtList];
		if(type == 'amt'){
			newList[index].EXCL_DON_AMT = val;
		}else if(type == 'bizcd'){
			newList[index].BIZ_CD = val;
		}else if(type == 'checked'){
			newList[index].checked = val;
		}else if(type == 'type'){
			setType(val);
		}
		if(type != 'type') setAmtList(newList);
		if(type == 'amt'){
			let sum = newList.reduce((total, amt) => {
				return Number(amt.EXCL_DON_AMT) + total
			}, 0);
			setTotalAmt(sum);
		}

		console.log('type : ' + type)
		console.log('val : ' + val)
	}

	function addList(){
		const nextAmt = amtList.concat({
			EXCL_DON_AMT : 0, BIZ_CD : '', num : nextNum, checked : false
		});
		setNextNum(nextNum + 1);
		setAmtList(nextAmt);
	}

	function deleteList(){
		if(amtList.filter(a => a.checked == true).length == 0){
			UIUtils.alert('삭제할 행을 선택해 주세요').then();
			return;
		}

		let newList = amtList.filter(function(data) {
			return !data.checked
		});

		if(newList.length != 0){
			let sum = newList.reduce((total, amt) => {
				return Number(amt.EXCL_DON_AMT) + total
			}, 0);
			setTotalAmt(sum); //삭제 후 토탈 재계산

			setAmtList(newList);
		}else{
			//전체 삭제시 초기화
			newList = [{ EXCL_DON_AMT : 0, BIZ_CD : '', num : 0 , checked : false}];
			setAmtList(newList);
			setTotalAmt(0);
			setIsAllChk(false);
			setNextNum(1);
		}


	}

	function isChecked(element)  {
		if(element.checked == false)  {
			return true;
		}
	}

	const checkBoxHandler = (e) => {

		if(e.target.name === 'ch-all'){
			setIsAllChk(e.target.checked);
		} else {
			let numReg = /[^0-9]/g;
			let name = e.target.name;
			let index = name.replace(numReg, '');
			changeVal(e.target.checked, 'checked', index);
		}
		if(e.target.name != 'ch-all'){
			let isAll = false;

			if(amtList.find(isChecked) == undefined){
				isAll = true;
			}
			setIsAllChk(isAll);

		}else{
			let newList = [...amtList];
			let allCheckBol = e.target.checked;
			newList = newList.map(e => {
				e.checked = allCheckBol;
				return e;
			});
			setAmtList(newList);
		}
	};

	async function chkValid(){

		let url = 'usr_2101_hando_chk';
		let param = {
			 "BIZ_CD": bizCd
			,"BIZ_NO": bizNo
		};


		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url:url,
			data: param
		})
		setSelectReaminDonAmt(response.REMAIN_DON_AMT);
		if(totalAmt <= Number(response.REMAIN_DON_AMT)){
			return 'none'
		}else{
			return 'amt'
		}


	}

	async function isChkValid(){

		if(!isChk){
			alertModalCheck();
			return false;
		}

		if(amtList.filter(a => (a.BIZ_CD == '' || a.BIZ_CD == '선택하세요')).length != 0){
			alertModal("[사업명]");
			return false;
		}
		
		if(amtList.filter(a => (a.EXCL_DON_AMT == 0)).length != 0){
			alertModal("[전용금액]");
			return false;
		}
		
		if(totalAmt == 0){
			alertModal("[전용 금액 합계]");
			return false;
		}

		if(fileInfoListPop.length == 0){
			alertModal("[전용신청공문]");
			return false;
		}

		let chk = await chkValid();
		if(chk == 'amt'){
			UIUtils.alert('전용신청 가능금액이 변경되어 잔액이 부족합니다.').then();
			return
		}else{
			confirmModal();
		}
		return false;

	}

	function dateToStr(dateText) {

		if(dateText == null) return '';

		if(/^(-?)[0-9]+$/.test(dateText)){
			dateText = Number(dateText);
		}
		let date = new Date(dateText);
		let week = new Array('일', '월', '화', '수', '목', '금', '토');


		let year = date.getFullYear();
		let month = date.getMonth()+1;
		let day = date.getDate();
		let dayName = week[date.getDay()];

		return year+'-'+dateLpad(month)+'-'+dateLpad(day)+'('+dayName+')';
	}

	function dateLpad(num){
		if(num.toString().length == 1){
			num = "0"+num;
		}

		return num;
	}

	async function saveConfirm(){
		//DON_CONT_DIV_CD -> type 기부내용코드 C현물 M금전

		let year = exclReqDate.getFullYear();
		let month = exclReqDate.getMonth()+1;
		let day = exclReqDate.getDate();

		let exclReqDateText = year+'-'+dateLpad(month)+'-'+dateLpad(day);

		let param = {
			"BIZ_NO": bizNo,
			"BIZ_CD": bizCd,
			"HAND_DATE": exclReqDateText,
			"ELEC_APPR_YN": elecApprYn,
			"NOTES": memo,
			"AMT_LIST": amtList,
			"PERSON_NM" : personNm,
			"PERSON_ID": personId,
			"POSI_NM" : posiNm,
			"DEPT_NM" : deptNm,
			"EMAIL_ADRES" : emailAdres,
			"OFC_TEL_NO" : ofcTelNo,
			"TOTAL_AMT" : totalAmt,
			'YEAR' : new Date().getFullYear()+'',
			FILE_INFO_LIST:fileInfoListPop.concat(fileInfoList)
		};


		//바로 저장 진행
		const response:any = await CommonUtil.execute({
			url:'usr_2007',
			data: param
		})

		const result = response;
		console.log(result)
		if(amtList.length != 1){
			//리스트 페이지로 이동
			let dataToSend = {};
			// 다른 페이지로 이동하면서 데이터 전달
			history.push({
				pathname: './usr_2009',
				state: { data: dataToSend }
			});
		}else{
			//상세로 갈수있도록 수정해야함 //전역변수에 값 넣을떄 같이 수정 // 06/10
			//리스트 페이지로 이동
			let dataToSend = {};
			// 다른 페이지로 이동하면서 데이터 전달
			history.push({
				pathname: './usr_2009',
				state: { data: dataToSend }
			});
		}

	}

	const alertModal = async (chk) => {
		const value = await UIUtils.alert(<>
			<div className='ta-center'> 필수 입력이 완료되지 않았습니다.<br/>
			다시 확인 후 저장해 주세요.<br/>
			{(chk=="" || chk == null ? "" : chk)}
			</div>
		</>);
	}
	
	const alertModalCheck = async () => {
		const value = await UIUtils.alert(<>
			<div className='ta-center'>필수 입력이 완료되지 않았습니다.<br/>
			전용신청 안내 동의(필수) 체크 여부 확인 바랍니다.</div>
		</>);
	}


	const confirmModal = async () => {
		const value = await UIUtils.confirm(
			<p className="msg">
				저장하시겠습니까?<br/>
			</p>
		);
		if(value){
			saveConfirm();
		}
		console.log("confirmModal", value);
	}



	// init
	React.useEffect(() => {

		codeDataStore.read(
			"cfms.portalBizCdList",
		)



		initCall();
		setModal2008IsOpen(true);

	},[])

	async function onClose(num) {
		if(num == '2007'){
			setModal2007IsOpen(false);
		}else if(num == '2008'){
			setModal2008IsOpen(false);
			// @ts-ignore
			IBSheet.sheet_modal.dispose();
		}


	}



	async function onAfterOpen(num) {
		if(num == '2139'){

		}else if(num == '2102') {

		}else if(num == '2149'){

		}else if(num == '2103'){
			return;
		}else if(num == '2104'){
			return;
		}

		ib_modal.create();
		return () => {
			// @ts-ignore
			ib_modal.disposeAll(true);
		}

	}

	//초기 데이터 설정
	let totalCnt:number = 0;
	let totalCntRight:number = 0;
	let defaultRowCnt = 20;

	let data_modal = {};
	let totalCnt_dev_modal;

	//====== 그리드 공통 부 START
	var ib_modal = ib_modal||{};
	ib_modal = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": defaultRowCnt,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"HeaderCheck": 1,
				"HeaderCheckMode": 1,
				"Height": "auto"

			},
			Def:{
				Row:{
					//AlternateColor: "FFFF00" // 하이라이트 색상을 노란색으로 설정
				}
			},
			//틀고정 좌측 컬럼 설정
			/*"LeftCols": [
				{"Header": "No","Name": "RN","Width": "90"}
			],*/
			"Cols": [
				{"Header": "No","Type": "Int", "Name": "RN","Align": "Center","RelWidth": 0.5,"CanEdit": "0"},
				{"Header": "출연사업","Type": "Text","Name": "BIZ_NM","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "출연상태","Type": "Text","Name": "DON_PROC_STS_NM","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "출연금액","Type": "Int","Name": "DON_AMT","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "전용가능잔액(원)","Type": "Int","Name": "REMAIN_DON_AMT","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "선택","Type": "Html","Name": "SELECT","RelWidth": 2,"Align": "Center" , "HtmlPostfix" : '<button class="bt" data-color="pri" data-size="md" type="button" >선택</button>'}
			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {

				//초기 데이터 로딩
				initSheet_modal();
			},
			//시트 더블클릭시 이벤트 처리
			onAfterClick:function(evtParam){
				if(evtParam.kind != "Header"){
					//왼쪽 시트에서 수정 진입
					if(evtParam.col == "SELECT" ){
						var sheet = evtParam.sheet;
						var row = sheet.getFocusedRow();
						setSelectBiz(row);
						setDonAmt(row.DON_AMT);
						setSelectReaminDonAmt(row.REMAIN_DON_AMT);
						setBizNm(row.BIZ_NM)
						setBizCd(row.BIZ_CD)

						onClose('2008')
					}
				}


			},
			//시트가 렌더링된 후 발생되는 이벤트입니다. 발생시점은 아래와 같은 부분에서 발생합니다.
			onRenderFinish  :function(evtParam){


			},
			onBeforeDataLoad:function (evtParam) {
				// 조회 후 로딩 전 발생 이벤트
				var d = evtParam.data;
				var _data;

				let sliceData = [];
				// 서버에서 가져온 데이터를 "데이터" 텝에 넣어준다.
				if (d.length > 20) { // 최대 20개 행만 텝에 넣어 주자(많아지면 화면이 엄청 느려질 수 있음)
					sliceData = d.slice(0, defaultRowCnt);
					_data = JSON.stringify(sliceData, null, 2);
					_data += _data.substring(0, _data.length - 1) + '...\n]';
				} else {
					_data = JSON.stringify(d, null, 2);
				}


			},
			onAfterGotoPage:function (evtParam) {

				var sheet = evtParam.sheet;
				var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
				//@ts-ignore
				if (currentPage != -1 && currentPage != page) {
					makePageIndex(page);
				}

				sheet.getDataRows().map(e => {
					e.Visible = 1;
					return e;
				})

				//현재 화면이 보이는 row가 0이 아닐때만
				if(sheet.getShownRows().length != 0){
					//화면에 보이는 row 제외 Visible 0 처리
					sheet.getDataRows().filter(x => !sheet.getShownRows().includes(x)).map(e => {
						e.Visible = 0;
						return e;
					});
				}

				//@ts-ignore
				sheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.



			}
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			//sheetId
			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet_modal', // 생성할 시트의 id
				el: 'modal_2008_List', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				//data: this.data // 생성될 시트의 정적데이터
			});


			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {

		},
		//조회 데이터
		'data':[]
	}

	//====== 그리드 공통 부  END


	async function initSheet_modal() {

		let param = {
			"BIZ_CD" : bizCd2008
		};

		let url = '';
		url = 'usr_2008.jct';


		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url:url,
			data: param
		})
		console.log(response);

		//전체데이터
		let result = response.REC;

		//전체ROW개수
		totalCnt = Object.keys(result).length;
		setTotalRowCnt(Object.keys(result).length);

		if(typeof result == 'undefined'){
			alert('data is not loaded!!!')
			return;
		}

		// @ts-ignore
		sheet_modal.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함

		// @ts-ignore
		sheet_modal.loadSearchData(result);


		// @ts-ignore
		makePageIndex(sheet_modal.getPageIndex( sheet_modal.getFocusedPage()) + 1); // 페이지 초기화



	};

	//====== 그리드 데이터 가지고 오기  END


	//====== 그리드 페이징 처리
	// @ts-ignore
	const makePageIndex = function (tp:number) {

		let pageNaviId = 'pageNavi';
		try {
			if (tp == null) {
				//@ts-ignore
				currentPage = -1;
				return;
			}

			// @ts-ignore
			if (document.getElementById(pageNaviId).firstChild) {
				// @ts-ignore
				document.getElementById(pageNaviId).removeChild(document.getElementById(pageNaviId).firstChild);
			}

			// @ts-ignore
			currentPage = tp;
			// @ts-ignore
			let sr = totalCnt // 전체 조회 건수
			// @ts-ignore
			let page = showRowCnt; // 페이지당 레코드 수
			let thispage = tp; // 현재 페이지
			let pagecnt = 5; // 한번에 표시할 페이지 개수
			let lastpage = Math.ceil(sr / page); // 마지막 페이지 인덱스
			let li, tt, a;
			let ul = document.createElement('DIV');
			// @ts-ignore
			ul.style.textAlign = 'center';


			let k = 1;

			if (thispage !== 1) {
				let ul_sub = document.createElement('DIV');
				ul_sub.className ="group";
				li = document.createElement('Button');
				li.className = 'item first';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				tt = document.createTextNode('<<');
				addEventHandler(li, 'click', pageMove, 1);

				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);

				li = document.createElement('Button');
				li.className = 'item prev';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, tp - 1);
				tt = document.createTextNode('<');
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);
			}

			sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
			let ul_sub2 = document.createElement('DIV');
			ul_sub2.className ="group";
			for (let i = sr; i < (sr + pagecnt); i++) {
				if (i <= lastpage) {
					li = document.createElement('Button');
					li.className ="item";
					a = document.createElement('a');
					a.style.cursor = 'pointer';
					tt = document.createTextNode(String(i));
					addEventHandler(li, 'click', pageMove, i);
					if (i === tp) {
						li.className ="item active";
					}
					a.appendChild(tt);
					li.appendChild(a);
					ul_sub2.appendChild(li);
					ul.appendChild(ul_sub2);
				}
			}

			if (thispage < lastpage) {
				let ul_sub3 = document.createElement('DIV');
				ul_sub3.className ="group";
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				li = document.createElement('Button');
				li.className = 'item next';
				tt = document.createTextNode('>');

				addEventHandler(li, 'click', pageMove, tp + 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);

				li = document.createElement('Button');
				li.className = 'item last';
				tt = document.createTextNode('>>');
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, lastpage);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);
			}

			ul.className = 'pg';
			// @ts-ignore
			document.getElementById(pageNaviId).appendChild(ul);
			if(sr == 0){
				// @ts-ignore
				document.getElementById(pageNaviId).appendChild('<div></div>');
			}
		} catch (ex) {
			// @ts-ignore
			alert(ex.message);
		}
	}

	//페이지 이동
	// @ts-ignore
	const pageMove = function (cPage:number) {

		// @ts-ignore
		sheet_modal.goToPageByIndex(cPage);

	}


	//페이지 이동 이벤트 핸들러
	// @ts-ignore
	const addEventHandler = function (obj, evtName, func, param) {
		if (obj.addEventListener) { // all browsers except IE before version 9
			obj.addEventListener(evtName, function () { func(param); }, false);
		} else if (obj.attachEvent) { // IE before version 9
			obj.attachEvent('on' + evtName, function () { func(param); });
		}
	}

	
	const manageSelect = (e) => {
		let selectManage = REC.filter(a => a.PERSON_ID == e.target.value);

		if(selectManage.length != 0){
			let info = selectManage[0];
			setPersonId(info.PERSON_ID)
			setCorpNm(info.CORP_NM);
			setBizNo(info.BIZ_NO);
			setCorpRegNo(info.CORP_REG_NO);
			setPersonNm(info.PERSON_NM);
			setPosiNm(info.POSI_NM);
			setDeptNm(info.DEPT_NM);
			setEmailAdres(info.EMAIL_ADRES);
			setOfcTelNo(info.OFC_TEL_NO);
		}
	
	};
	

	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<Breadcrumb gnbIdx={1} lnbIdx={2}/>
				<main className="fww-main">
					<h1 className="tx tx-hd2">전용신청</h1>
					<section className="fund-section">
						<div className="hz-root hz-gap10 hz-sb mb15">
							<h3 className="section-title">전용신청 안내동의</h3>
							<p className="tx-msg"><span className="fc-pri">*</span>&nbsp;필수 입력</p>
						</div>
						<form className="sf sf-1row" name="" action="" method="">
							<div className="hz-root hz-sb">
								<label htmlFor="ch-1" className="hz-item ip-ch-label ip-ch-18">
									<input id="ch-1" className="ip-ch" type="checkbox" checked={isChk} onChange={(e) => setIsChk(e.target.checked)} />
									<span className="check"></span>
									<span className="txt fw400">안내사항을 확인하였으며, 안내사항에 동의합니다(필수)</span>
								</label>
								<Button color="gray-o" size="sm" onClick={() => {setModal2007IsOpen(true)}}>안내사항 보기</Button>
							</div>
						</form>
					</section>
					<section className="fund-section">
						<h3 className="section-title mb15">전용 신청 일자</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item req">
									<p className="fo-key">전용요청일</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={dateToStr(exclReqDate)} placeholder={''} readOnly={true} />  {/* [M.20240603] 수정 */}
									</div>
								</div>
							</div>
						</form>
					</section>
					<section className="fund-section">
						<h3 className="section-title mb15">출연 내용</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<p className="fo-key">출연사업</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={bizNm} placeholder={''} readOnly={true} />
										<div className="tx-msg ml10">
											<Button color="gray-o" size="md" onClick={() => {setModal2008IsOpen(true);}}>출연사업선택</Button>
										</div>
									</div>
								</div>
								<div className="fo-item">

								</div>
								<div className="fo-item">
									<p className="fo-key">출연금액</p>
									<div className="fo-value">
										<div className="fund-form-group">
											<div className="fund-form-items tf-unit">
												<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(donAmt)) || "0"} placeholder={''}  readOnly={true} />
												<span className="u">원</span>
											</div>
											<div className="tx-msg ml10"><span className="fc-pri">({StringUtil.isNotEmpty(donAmt + "")
															? StringUtil.numKorPattern(donAmt) + " 원"
															: "원"})</span></div>
										</div>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">전용가능잔액(원)</p>
									<div className="fo-value">
										<div className="fund-form-group">
											<div className="fund-form-items tf-unit">
												<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(selectReaminDonAmt)) || "0"} placeholder={''}  readOnly={true} />
												<span className="u">원</span>
											</div>
											<div className="tx-msg ml10"><span className="fc-pri">({StringUtil.isNotEmpty(selectReaminDonAmt + "")
															? StringUtil.numKorPattern(selectReaminDonAmt) + " 원"
															: "원"})</span></div>
										</div>
									</div>
								</div>
							</div>
						</form>
					</section>
					<section className="fund-section">
						<div className="hz-root hz-sb mb15">
							<div className="hz-root hz-gap10 hz-item">
								<h3 className="section-title">전용 요청 금액</h3>
								<p className="tx-msg"><span className="fc-pri">※ 최소 1개 이상을 입력해야 합니다.</span></p>
							</div>
							<div className="hz-root hz-gap5">
								<Button color='pri-o' size="sm" onClick={addList}>행추가</Button>
								<Button color='gray-o' size="sm" onClick={deleteList}>행삭제</Button>
							</div>
						</div>
						<form name="" action="" method="">
							<div className="tb tb-narrow">
								<table>
									<caption></caption>
									<colgroup>
										<col width="60px" />
										<col />
										<col />
									</colgroup>
									<thead>
										<tr>
											<th>
												<label htmlFor="ch-all" className="hz-item ip-ch-label ip-ch-18">
													<input id="ch-all" className="ip-ch" type="checkbox" name={'ch-all'} checked={isAllChk} onChange={(e) => checkBoxHandler(e)}/>
													<span className="check"></span>
												</label>
											</th>
											<th scope="col"><span className="th-req">사업명 선택</span></th>
											<th scope="col"><span className="th-req">전용금액(원)</span></th>
										</tr>
									</thead>
									<tbody>
										{amtList.map((amt, idx) => (
											<tr key={idx}>
												<td>
													<label htmlFor={'ch-t1'+idx} className="hz-item ip-ch-label ip-ch-18">
														<input id={'ch-t1'+idx} className="ip-ch" name={'isChk'+idx} type="checkbox" checked={amt.checked} onChange={(e) => checkBoxHandler(e)} />
														<span className="check"></span>
													</label>
												</td>
												<td>
													<div className="sl sl-md">
														<select name={'selectBizCd'+idx} onChange={(e) => handleSelect(e)}>
															<option>선택하세요</option>
															{codeDataStore.get("cfms.portalBizCdList").map((sec, idx) =>
																<option key={idx} value={sec.code}>{sec.name}</option>
															)}
														</select>
													</div>
												</td>
												<td>
													<div className="fund-form-group">
														<div className="fund-form-items tf-unit">
															<UIInput className={'tf tf-md ta-right'}
																 value={StringUtil.formatNumber(Number(amt.EXCL_DON_AMT)) || "0"}
																 valueChanged={(value) => {
																	 let tmpVal = value.replace(/[^0-9]/g, "");
																	 changeVal(tmpVal, 'amt', idx);
																 }}
																 attrs={{ maxLength: 21 }}
															/>
															<span className="u">원</span>
														</div>
														<div className="tx-msg ml10"><span className="fc-pri">({StringUtil.isNotEmpty(amt.EXCL_DON_AMT + "")
															? StringUtil.numKorPattern(amt.EXCL_DON_AMT) + " 원"
															: "원"})</span></div>
													</div>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
							<div className="tb-total">
								<div className="tb-total-items">전용 금액 합계</div>
								<div className="tb-total-items">
									<div className="fund-form-items tf-unit">
										<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(totalAmt)) || "0"} placeholder={''}  readOnly={true}/>
										<span className="u">원</span>
									</div>
									<p className="tx-msg"><span className="fc-pri">(
										{StringUtil.isNotEmpty(totalAmt + "") ?
										 StringUtil.numKorPattern(totalAmt) + " 원" : "원"}
									)</span></p>
								</div>
							</div>
						</form>
					</section>
					<section className="fund-section">
						<h3 className="section-title mb15">비고사항</h3>
						<form name="" action="" method="">
							<div className="ta-group w100p">
								<UITextArea className={'ta-ip'} value={memo} valueChanged={(value) => {setMemo(value)}} />
							</div>
						</form>
					</section>
					<section className="fund-section">
						<h3 className="section-title mb15">첨부파일</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item fo-m-1-3 req">
									<div className="fo-key">
										전용신청공문
									</div>
									<div className="fo-value">
										<div className="fund-form-group">
											<div className="fund-form-items mr30">
												<div className="hz-root hz-gap8 w100p">
													<UIInput className={'tf tf-md hz-item grow'} value={reqFileNm} placeholder={'파일을 첨부해 주세요.'} />
													<div className="hz-root hz-gap8 ">
														<Button color='pri-o2' size="md" onClick={reqModal}>찾기</Button>
														<Button color='gray-o' size="md">삭제</Button>
													</div>
												</div>
											</div>


										</div>
									</div>
								</div>
							</div>
						</form>
						<UI.FileUpload
							onCreationComplete={onCreationComplete}
							onUploadComplete={onUploadComplete}
							attrs={{
								MaxTotalFileCount: "1",
								ExtensionAllowOrLimit: "1",
								Width:"100%",
								ImgPreView: "1",
								Views: "thumbs"
							}}
						/>
					</section>
					<section className="fund-section">
						<h3 className="section-title mb15">기업 정보</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<p className="fo-key">기업명</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={corpNm} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">법인사업자번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={corpRegNo} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">사업자번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={StringUtil.bizCrpFormat(bizNo)} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">담당자</p>
									<div className="fo-value">
										{/*<UIInput className={'tf tf-md w100p'} value={personNm} valueChanged={(value) => {setPersonNm(value)}} placeholder={''}/>*/}
										<div className="sl sl-md w120">
											<select name="personId" id="personId" value={personId} onChange={(manageSelect)}>
												{REC.map((info, idx) => (
													<option value={info.PERSON_ID}>{info.PERSON_NM}</option>
												))}
											</select>
										</div>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">직급</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={posiNm} valueChanged={(value) => {setPosiNm(value)}} placeholder={''} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">부서</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={deptNm} valueChanged={(value) => {setDeptNm(value)}} placeholder={''} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">이메일</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={emailAdres} valueChanged={(value) => {setEmailAdres(value)}} placeholder={''} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">전화번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={StringUtil.telephoneFormat(ofcTelNo)} valueChanged={(value) => {setOfcTelNo(value)}} placeholder={''} />
									</div>
								</div>
							</div>
						</form>
					</section>
					<div className="hz-root hz-right hz-gap10 mt30">
						<Button color="gray-o" size="md" href={'/main/usr_2000/usr_2009'}>취소</Button>
						<Button color="pri" size="md" onClick={() => isChkValid()}>저장</Button>
					</div>
				</main>
			</div>
			{/* modal - 전용신청 안내사항 */}
			<ModalPopup
				open={modal2007IsOpen}
				title="전용신청 안내사항"
				size="mid"
				onClose={() => onClose('2007')}
			>
				<div className="modal-con">
					<div className="fww-noti">
						<section className="mb30">
							<h3>전용신청절차</h3>
							<div className="step fund">
								<dl>
									<dt>01 출연선택</dt>
									<dd>전용이 가능한 <br />출연사업을 선택</dd>
								</dl>
								<dl>
									<dt>02 전용신청</dt>
									<dd>전용할 사업과 <br />전용금액을 입력</dd>
								</dl>
								<dl>
									<dt>03 전용공문</dt>
									<dd>전용공문을 첨부</dd>
								</dl>
								<dl>
									<dt>04 전용신청완료</dt>
									<dd>모든 신청정보를 <br />입력 후 제출</dd>
								</dl>
							</div>
						</section>
						<dl className="guide mb15">
							<dt>유의사항</dt>
							<dd>
								<ul className="list-group">
									<li>전용신청 시 출연사업을 지정하여 전용신청을 해야 합니다.</li>
									<li>전용가능금액 한도 내에서 신청이 가능합니다.</li>
									<li>전용신청 시 자사별 전용공문을 첨부해야 제출할 수 있습니다.</li>
								</ul>
							</dd>
						</dl>
						<div className="tx-msg"><span className="fc-pri">※ 전용공문은 재단에서 별도로 제공하고 있지 않습니다. 자사에서 구비중인전용공문을 준비해 주세요.</span></div>
					</div>
				</div>
				<div className="modal-bottom">
					<Button color="pri" size="md" onClick={() => onClose('2007')}>확인</Button>
				</div>
			</ModalPopup>
			{/* modal - 전용 처리할 출연 선택 */}
			<ModalPopup
				open={modal2008IsOpen}
				title="전용 처리할 출연 선택"
				size="lg"
				onClose={() => onClose('2008')}
				onAfterOpen={() => onAfterOpen('2008')}
			>
				<div className="modal-con">
					<form className="fo fo-col2" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-item fo-m-1-3">
								<p className="fo-key">출연사업명</p>
								<div className="fo-value">
									<div className="sl sl-md w100p">
										<UISelect
											value={bizCd2008}
											valueChanged={(value) => setBizCd2008(String(value))}
											codeData={codeDataStore.get("cfms.portalBizCdList")}
											firstName={"sel"}
										/>
									</div>
								</div>	
							</div>
						</div>
					</form>
					<div className="hz-root hz-center mb30">
						<Button color="pri" size="md" onClick={() => initSheet_modal()}>조회</Button>
					</div>
					<div id="modal_2008_List">[D] IBSHEET 영역</div>
					<div id="pageNavi" className="pg"></div>
				</div>
				<div className="modal-bottom">
					<Button color="pri" size="md" onClick={() => onClose('2008')}>확인</Button>
				</div>
			</ModalPopup>
		</PageContainer>
	);
}
export default ContentsContainer;